import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {baseUrl} from "../index"
import axios from 'axios';
import { getAuthToken } from '../../utils/utils';


// Async thunk to fetch programs
export const getDropouts = createAsyncThunk(
  'dropouts/getDropouts',
  async (userId, thunkAPI) => {
    try {
const token = getAuthToken();

      const response = await axios.get(baseUrl+'/studentsdrops', {
        params: { userId },// Send userId to get user-specific data
        headers: {
          'Authorization': `${token}`,  // Pass the token here
          'Content-Type': 'application/json',  // Make sure the content type is correct
        } 
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);


// Async thunk to create a program
export const updateDropouts = createAsyncThunk(
  'dropouts/updateDropouts',
  async (programData, thunkAPI) => {
    try {
const token = getAuthToken();

      const response = await axios.put(baseUrl+'/studentsdrops/year', programData ,{
        headers: {
          'Authorization': `${token}`,  // Pass the token here
          'Content-Type': 'application/json',  // Make sure the content type is correct
        }
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const dropOutSlice = createSlice({
  name: 'dropOuts',
  initialState: {
    dropoutPrograms: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDropouts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDropouts.fulfilled, (state, action) => {
        state.loading = false;
        state.dropoutPrograms = action.payload;
      })
      .addCase(getDropouts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateDropouts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDropouts.fulfilled, (state, action) => {
        state.loading = false;
        
      })
      .addCase(updateDropouts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default dropOutSlice.reducer;